var escape = require("../../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2p1tg_FGxt3yHa{position:relative;line-height:10px}._208wc3JatPlTro:hover{background-color:#c1c7d0}._208wc3JatPlTro._3V9hIyKy3-DOOf{position:relative}._208wc3JatPlTro._3V9hIyKy3-DOOf:hover:before{opacity:.2}._208wc3JatPlTro._3V9hIyKy3-DOOf:before{background-color:#c1c7d0;border-radius:50%;content:\"\";height:100%;left:0;opacity:0;position:absolute;top:0;width:100%}._3D79Y2OPyhRk8P,._118WCYqvW0giiM{background-size:100%;position:absolute;z-index:3;right:1px}._3D79Y2OPyhRk8P{height:7px;width:11px;top:1px;background-image:url(" + escape(require("images/TrelloGoldBadge.png")) + ")}._118WCYqvW0giiM{height:9px;width:9px;bottom:0;background-image:url(" + escape(require("images/chevron.png")) + ")}", ""]);

// exports
exports.locals = {
	"memberAvatar": "_2p1tg_FGxt3yHa",
	"hoverable": "_208wc3JatPlTro",
	"withImage": "_3V9hIyKy3-DOOf",
	"gold": "_3D79Y2OPyhRk8P",
	"admin": "_118WCYqvW0giiM"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[hash:base64:14]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-3053/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/gamma/src/components/member-avatar/member-avatar.less
// module id = NTl4
// module chunks = 24